import { render, staticRenderFns } from "./headerSouthernEn.vue?vue&type=template&id=1e4fdc5b&scoped=true"
import script from "./headerSouthernEn.vue?vue&type=script&lang=js"
export * from "./headerSouthernEn.vue?vue&type=script&lang=js"
import style0 from "./headerSouthernEn.vue?vue&type=style&index=0&id=1e4fdc5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4fdc5b",
  null
  
)

export default component.exports